import React, { useEffect, useState } from "react";
import useAuthEffect from "../../hook/useAuthEffect";
import { useDispatch, useSelector } from "react-redux";
import { fetchUsers } from "../../redux/ducks/user";

const ContractorSelect = (props) => {
  const dispatch = useDispatch();
  const users = useSelector((state) => state.user.users);

  useAuthEffect(() => {
    dispatch(fetchUsers());
  }, []);

  return (
    <select
      onChange={(e) => {
        props.onSelect(e.target.value);
      }}
      className={"select select--primary " + props.className}
    >
      <option selected disabled></option>
      {/*  {Object.keys(users).map((key, index) => {
        if (users[key].role == "contractor") {
          return (
            <option value={key}>
              {users[key].firstname} {users[key].lastname}
            </option>
          );
        }
      })}*/}

      {Object.entries(users)
        // only contractors
        .filter(([, user]) => user.role === "contractor")
        // sort by firstName, then lastName, then username
        .sort(([, a], [, b]) => {
          const byFirst = (a.firstname ?? "").localeCompare(
            b.firstname ?? "",
            "en",
            {
              sensitivity: "base",
            },
          );
          if (byFirst !== 0) return byFirst;

          const byLast = (a.lastname ?? "").localeCompare(
            b.lastname ?? "",
            "en",
            {
              sensitivity: "base",
            },
          );
          if (byLast !== 0) return byLast;

          return (a.username ?? "").localeCompare(b.username ?? "", "en", {
            sensitivity: "base",
          });
        })
        // render options
        .map(([key, user]) => (
          <option key={key} value={key}>
            {user.firstname ?? ""} {user.lastname ?? ""}
          </option>
        ))}
    </select>
  );
};

export default ContractorSelect;
